import { IOrderLineDto} from "Apis/Models/IOrderDto";
import styles from './OrderLineDetails.module.scss';
import {Trans, useTranslation} from "react-i18next";
import {formatNumber} from "../../../Utils/NumberUtils";
import CheckmarkIcon from "../../../Assets/SVG/CheckmarkIcon";
import XIcon from "../../../Assets/SVG/XIcon";
import { useNavigate } from "react-router-dom";
import {
    getOrderLineUnitSalesPrice,
    getOrderLineTotal,
    getOrderLineTotalCost,
    getOrderLineUnitCost
} from "../Utils/OrderLineUtils";
import {useCheckProductStock} from "../../../Apis/ProductApi";
import React from "react";

interface IProps {
    orderLine: IOrderLineDto;
}
const OrderLineDetails = (props: IProps) => {

    const { t } = useTranslation();

    const navigate = useNavigate();

    const { orderLine } = props;

    const { data: stockInfo } = useCheckProductStock(props.orderLine.product.id);

    return (
        <div className={styles.container}>
            <div className={styles.img}>
                {!!orderLine.product.productImages?.find(Boolean) && (
                    <img height={100} width={100} src={orderLine.product.productImages?.find(Boolean)?.url} alt={""}/>
                )}
            </div>

            <div>
                <div className={styles.header}>
                    {t('product')}
                </div>

                <div className={`${styles.title} ${styles.link}`} onClick={() => navigate(`/products/edit/${orderLine.productId}`)}>
                    {orderLine.product.readyForUse ? <CheckmarkIcon/> : <XIcon/>} {orderLine.product.name}
                </div>

                <div className={`${styles.subtitle}`}>
                    {t('sku')}: {orderLine.product.sku}
                </div>

                <div className={styles.subtitle}>
                    {orderLine.comment}
                </div>

                {(!!stockInfo && stockInfo.qtyInStock !== null) && (
                    <div style={{ color: stockInfo.qtyInStock > 0 ? 'green' : 'red'}}>
                        <Trans i18nKey={`inStockQuantity`} values={{ qty: stockInfo.qtyInStock }} />
                    </div>
                )}

                {!!orderLine.orderReference && (
                    <div className={`${styles.subtitle} clickable`} onClick={() => navigate(`/orders/${orderLine.orderReference}`)}>
                        Vis oprindelig ordre
                    </div>
                )}
            </div>

            <div>
                {orderLine.product.productType === 'Product' && (
                    <>
                        <div className={styles.header}>
                            {t('inventoryItem')}
                        </div>
                        <div className={styles.title}>
                            {orderLine.product?.inventoryItem?.name}
                        </div>
                        <div className={styles.subtitle}>
                            {orderLine.product?.inventoryItem?.sku}
                        </div>
                    </>
                )}
            </div>

            <div>
                <div style={{paddingBottom: '16px'}}>
                    <div className={styles.header}>
                        {t('salesPrice')}
                    </div>
                    <div className={styles.title}>
                        {orderLine.quantity} X {formatNumber(getOrderLineUnitSalesPrice(orderLine))} DKK
                    </div>
                    <div className={styles.subtitle}>
                        {formatNumber(getOrderLineTotal(orderLine))} DKK
                    </div>

                </div>
                <div>
                    <div className={styles.header}>
                        {t('costPrice')}
                    </div>
                    <div className={styles.subtitle}>
                        {orderLine.quantity} X {formatNumber(getOrderLineUnitCost(orderLine))} DKK
                    </div>
                    <div className={styles.subtitle}>
                        {formatNumber(getOrderLineTotalCost(orderLine))} DKK
                    </div>
                </div>
            </div>

        </div>
    )

}

export default OrderLineDetails;